import React, { useEffect } from 'react';
import { BrowserRouter as Router, Routes, Route, useLocation } from 'react-router-dom';
import Navigation from './components/Navigation/Navigation';
import Footer from './components/Footer/Footer';
import Home from './pages/Home/Home';
import About from './pages/About/About';
import WhyUnique from './pages/WhyUnique/WhyUnique';
import CourseDetails from './pages/Courses/CourseDetails';
import JEEMainAdvanced from './pages/Courses/JEEMainAdvanced';
import NEETPreparation from './pages/Courses/NEETPreparation';
import FoundationOlympiad from './pages/Courses/FoundationOlympiad';
import OlympiadPage from './pages/Courses/OlympiadPage';
import Results from './pages/Results/Results';
import Contact from './pages/Contact/Contact';
import Philosophy from './pages/Philosophy/Philosophy';
import Scholarship from './pages/Scholarship/Scholarship';
import Terms from './pages/Terms/Terms';
import NotFound from './pages/404/NotFound';
import OurStudent from './components/testimonials/OurStudent';
import DostPage from './components/dost/page';
import { ThemeProvider } from './contexts/ThemeContext';
import { initGA, trackPageView } from './utils/analytics';

const ScrollToTop: React.FC = () => {
  const location = useLocation();

  useEffect(() => {
    window.scrollTo(0, 0);
    // Track page view in Google Analytics
    trackPageView(location.pathname + location.search);
  }, [location.pathname, location.search]);

  return null;
};

const AppLayout: React.FC = () => {
  const location = useLocation();
  const isDostRoute = location.pathname === "/dost";

  return (
    <div className={`app ${isDostRoute ? "app--dost" : ""}`}>
      {!isDostRoute ? <Navigation /> : null}
      <main className="main-content">
        <Routes>
          <Route path="/" element={<Home />} />
          <Route path="/home" element={<Home />} />
          <Route path="/about" element={<About />} />
          <Route path="/why-unique" element={<WhyUnique />} />
          <Route path="/courses" element={<CourseDetails />} />
          <Route path="/courses/jee-main-advanced" element={<JEEMainAdvanced />} />
          <Route path="/courses/neet-preparation" element={<NEETPreparation />} />
          <Route path="/courses/foundation-olympiad" element={<FoundationOlympiad />} />
          <Route path="/courses/olympiad" element={<OlympiadPage />} />
          <Route path="/results" element={<Results />} />
          <Route path="/contact" element={<Contact />} />
          <Route path="/philosophy" element={<Philosophy />} />
          <Route path="/scholarship" element={<Scholarship />} />
          <Route path="/our-students" element={<OurStudent />} />
          <Route path="/dost" element={<DostPage />} />
          <Route path="/terms" element={<Terms />} />
          <Route path="*" element={<NotFound />} />
        </Routes>
      </main>
      {!isDostRoute ? <Footer /> : null}
    </div>
  );
};

const App: React.FC = () => {
  useEffect(() => {
    // Initialize Google Analytics
    initGA();
  }, []);

  return (
    <ThemeProvider>
      <Router>
        <ScrollToTop />
        <AppLayout />
      </Router>
    </ThemeProvider>
  );
};

export default App;
